module.exports = __webpack_public_path__ + "static/media/compare_57.b0aad613.svg";